import React from 'react';

import { getImageLink } from '../../config/global';

export const renderImage = (path: string, classname: string): JSX.Element => {
    const imagePath = getImageLink(path);

    return <img className={classname} src={imagePath} alt={imagePath} />
};